import React, { useRef, useState, useEffect } from "react";
import "./Testimonial.css";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";

import "swiper/css";
import "swiper/css/navigation";

SwiperCore.use([Navigation]);

const Testimonial = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const [swiperReady, setSwiperReady] = useState(false);

  useEffect(() => {
    setSwiperReady(true);
  }, []);

  return (
    <section className="testimonial-wrapper">
      <div className="container swiper-container">

        <div className="testimonial-header">
          <span className="badge">Testimonials</span>
          <h2>What Our Travelers Say</h2>
          <p>Real feedback from our happy customers</p>
        </div>

        {swiperReady && (
          <Swiper
            spaceBetween={30}
            slidesPerView={3}
            loop={false}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            onInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
              swiper.navigation.init();
              swiper.navigation.update();
            }}
          >
            <SwiperSlide>
              <div className="testimonial-box">
                <p>
                  Everything was well planned and executed perfectly.
                  Hotels, transport and sightseeing were excellent.
                </p>
                <div className="testimonial-user">
                  <div>
                    <h5>Rohit Sharma</h5>
                    <span>Delhi, India</span>
                  </div>
                  <div className="rating">★★★★★</div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="testimonial-box">
                <p>
                  Amazing experience with Plenary Holidays.
                  The team was always available and supportive.
                </p>
                <div className="testimonial-user">
                  <div>
                    <h5>Anjali Verma</h5>
                    <span>Mumbai, India</span>
                  </div>
                  <div className="rating">★★★★★</div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="testimonial-box">
                <p>
                  Transparent pricing and very professional service.
                  Will definitely book again.
                </p>
                <div className="testimonial-user">
                  <div>
                    <h5>Rahul Mehta</h5>
                    <span>Ahmedabad, India</span>
                  </div>
                  <div className="rating">★★★★☆</div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="testimonial-box">
                <p>
                  Transparent pricing and very professional service.
                  Will definitely book again.
                </p>
                <div className="testimonial-user">
                  <div>
                    <h5>Simran Sharma</h5>
                    <span>Delhi, India</span>
                  </div>
                  <div className="rating">★★★★☆</div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        )}

        {/* Custom Arrows */}
        <div className="custom-swiper-prev" ref={prevRef}>
          <AiOutlineLeft size={20} />
        </div>
        <div className="custom-swiper-next" ref={nextRef}>
          <AiOutlineRight size={20} />
        </div>

      </div>
    </section>
  );
};

export default Testimonial;
